import types from '../types'
import Action from '../../types/Action'

const initialState = {
  carePlanToSign: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  carePlanGrid: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateProviderAcknowledge: {
    loading: false,
    success: false,
    data: []
  },
}

const carePlanReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.GET_CARE_PLAN_TO_SIGN_REQUESTED: {
      return {
        ...state,
        carePlanToSign: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.GET_CARE_PLAN_TO_SIGN_FULFILLED: {
      return {
        ...state,
        carePlanToSign: {
          ...state.carePlanToSign,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.GET_CARE_PLAN_TO_SIGN_REJECTED: {
      return {
        ...state,
        carePlanToSign: {
          ...state.carePlanToSign,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.GET_CARE_PLAN_GRID_REQUESTED: {
      return {
        ...state,
        carePlanGrid: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.GET_CARE_PLAN_GRID_FULFILLED: {
      return {
        ...state,
        carePlanGrid: {
          ...state.carePlanGrid,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.GET_CARE_PLAN_GRID_REJECTED: {
      return {
        ...state,
        carePlanGrid: {
          ...state.carePlanGrid,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_PROVIDER_ACKNOWLEDGE_REQUESTED: {
      return {
        ...state,
        updateProviderAcknowledge: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.UPDATE_PROVIDER_ACKNOWLEDGE_FULFILLED: {
      const updatedAcknowledgeState = action.payload.mailSent ? {
        success: true,
        data: action.payload.carePlansToSign
      } : {
        error: { response: { text: '<div style=\'font-size: 16px\'>These Care Plans have been acknowledged but the confirmation email could not be sent.</div>' } }
      }
      return {
        ...state,
        updateProviderAcknowledge: {
		      ...state.updateProviderAcknowledge,
          ...updatedAcknowledgeState,
          loading: false
        },
        carePlanToSign: {
		      ...state.carePlanToSign,
          data: action.payload.carePlansToSign
        },
        carePlanGrid: {
          ...state.carePlanGrid,
          data: action.payload.carePlansGrid
        }
      }
    }
	  case types.UPDATE_PROVIDER_ACKNOWLEDGE_REJECTED: {
      return {
        ...state,
        updateProviderAcknowledge: {
		      ...state.updateProviderAcknowledge,
          loading: false,
          error: action.payload
        }
      }
    }
    default:
      return state
  }
}

export default carePlanReducer